import { FC } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../constants/routes";

interface LogoProps {
  variant?: "light" | "dark";
  size?: "small" | "large";
  iconOnly?: boolean;
}

const Logo: FC<LogoProps> = ({ variant = "dark", size = "small", iconOnly = false }) => {
  const { t } = useTranslation('common');

  const sizeConfigs = {
    small: {
      height: 40,
    },
    large: {
      height: 76,
    },
  };

  return (
    <Link to={ROUTES.HOME}>
      <img
        src={iconOnly ? "/logo192.png" : "/logo512.png"}
        alt={t('logo.alt')}
        loading="lazy"
        height={sizeConfigs[size].height}
      />
    </Link>
  )
};

export default Logo; 